import messagesEn from 'config/translations/en.json';

export type IntlMessageKeys = keyof typeof messagesEn;

export const translationMessages = {
  en: messagesEn,
};
